import $ from 'jquery';
import _ from 'underscore';
import ajax from 'util/ajax';
import { CLASS_NAME_DISABLED, CLASS_NAME_HIDE, CMP_RELOADING_FLAGS } from 'util/constants';
import { $body } from 'util/global';

const TEXTAREA_KEYDOWN_EVENT_NAME = 'keydown.shownote';

/**  @param {JQuery} $container */
function checkEmailVerification($container) {
  $container.find('#solvable-resend-verification-form').trigger('submit');
}

/**
 * @param {JQuery} $container
 */
function bindRadioInputEvents($container) {
  const $radios = $container.find('input[type=radio]');
  const $chooseButton = $container.find('.choose-choice');
  const $cancelLink = $container.find('.cancel');
  const $autosaveNote = $container.find('.note');
  const ANIMATION_TIME = 250; // ms

  $radios.on('change', () => {
    $chooseButton.toggleClass(CLASS_NAME_DISABLED, $radios.filter(':checked').length === 0);
  });

  $chooseButton.on('click', e => {
    e.preventDefault();

    const $choice = $radios.filter(':checked');

    if (!$choice.length) {
      return;
    }

    $chooseButton.hide();

    const $form = $container.find(`.${$choice.val()}`);

    $container.addClass('out');
    setTimeout(() => {
      $container.find('.options').hide();
      $form.add($cancelLink).show();
      // show the autosave note again if necessary
      $form.find('textarea').triggerHandler(TEXTAREA_KEYDOWN_EVENT_NAME);
      $container.removeClass('out');
    }, ANIMATION_TIME);
  });

  $cancelLink.on('click', e => {
    e.preventDefault();
    $container.addClass('out');
    setTimeout(() => {
      $container.find('.options').add($chooseButton).show();
      $container.find('.choice').filter(':visible').add($cancelLink).hide();
      $autosaveNote.addClass(CLASS_NAME_HIDE);
      $container.removeClass('out');
    }, ANIMATION_TIME);
  });
}

/** @param {JQuery} $container */
function bindTextareaEvents($container) {
  const $textareas = $container.find('textarea');
  const $autosaveNote = $container.find('.note');

  $textareas.on(
    TEXTAREA_KEYDOWN_EVENT_NAME,
    _.throttle(e => {
      // new value will be accessible only on the next JS run loop
      // that is why we get it within the deferred function
      _.defer(() => {
        $autosaveNote.toggleClass(CLASS_NAME_HIDE, e.currentTarget.value.length === 0);
      });
    }, 250),
  );
}

/**
 * Controller for solvable dispute modal
 * @param {JQuery} $modal
 */
export function modal($modal) {
  const data = $modal.data();
  const $trigger = $(data.trigger);
  let $clonedModal;
  let clonedModalData;

  const updateSolvableComponent = () => {
    $body.data(CMP_RELOADING_FLAGS.DISPUTES, true);
    ajax('assessment').get(data.solvableUrl, {
      page_key: data.pageKey,
    });
  };

  const bindModalEvents = _.once(() => {
    bindTextareaEvents($clonedModal);
    if (!clonedModalData.showAtStart) {
      checkEmailVerification($clonedModal);
    }
    bindRadioInputEvents($clonedModal);

    $clonedModal.find('form').on('submit', () => {
      $body.data(CMP_RELOADING_FLAGS.DISPUTES, true);
    });

    $clonedModal.on('hide', () => {
      if (data.endstate) {
        updateSolvableComponent();
      }
    });
  });

  const showModal = () => {
    bindModalEvents();
    $clonedModal.modal('show');
  };

  // remove other dispute modals
  $body.children('.modal-bg').has('.dispute-form-modal').remove();

  $trigger.on('click', e => {
    e.preventDefault();
    showModal();
  });

  // defer this to clone the modal AFTER all general event handlers (like autosubmit) are bound
  _.defer(() => {
    $clonedModal = $modal.clone(true, true);
    clonedModalData = $clonedModal.data();
    if (clonedModalData.showAtStart) {
      showModal();
    }
  });
}

/** @param {JQuery} $webview */
export function webview($webview) {
  checkEmailVerification($webview);
  bindRadioInputEvents($webview);
}
